import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/**
 * Address rows. There is no dedicated pin glyph, so this reuses the design-system `MapMarkerOutlineIcon` (a filled 10×10
 * glyph, drawn at `size`) - to be replaced once design delivers a stroke icon matching the others.
 */
export const PricesSearchPinIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <span className={cx(iconWrapperStyle, className)} data-testid={dataTestId} aria-hidden="true">
            <MapMarkerOutlineIcon width={size} height={size} fill="currentColor" />
        </span>
    );
};

const iconWrapperStyle = css({
    display: "inline-flex"
});
import {css, cx} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import type {ISearchComboboxIconProps} from "@pg-design/search-combobox-module";

/**
 * Address rows. There is no dedicated pin glyph, so this reuses the design-system `MapMarkerOutlineIcon` (a filled 10×10
 * glyph, drawn at `size`) - to be replaced once design delivers a stroke icon matching the others.
 */
export const PricesSearchPinIcon = (props: ISearchComboboxIconProps) => {
    const {size = 20, className, dataTestId} = props;

    return (
        <span className={cx(iconWrapperStyle, className)} data-testid={dataTestId} aria-hidden="true">
            <MapMarkerOutlineIcon width={size} height={size} fill="currentColor" />
        </span>
    );
};

const iconWrapperStyle = css({
    display: "inline-flex"
});
